import React from 'react';
import * as THREE from 'three';
import { Line } from '@react-three/drei';

interface PerpPreviewLineProps {
  startPoint: { x: number; y: number; z: number };
  referenceBeam: { startPoint: THREE.Vector3; endPoint: THREE.Vector3 };
}

export const PerpPreviewLine: React.FC<PerpPreviewLineProps> = ({
  startPoint,
  referenceBeam
}) => {
  // Convert startPoint to Vector3
  const nodePoint = new THREE.Vector3(startPoint.x, startPoint.y, startPoint.z);

  // Create a line representing the reference beam direction
  const beamDirection = referenceBeam.endPoint.clone().sub(referenceBeam.startPoint);
  beamDirection.normalize();

  // Calculate the perpendicular point on the beam
  const nodeToStart = nodePoint.clone().sub(referenceBeam.startPoint);
  const projection = nodeToStart.dot(beamDirection);
  const perpPoint = referenceBeam.startPoint.clone().add(beamDirection.clone().multiplyScalar(projection));

  // Create the points array for the preview line
  const points = [
    nodePoint,
    perpPoint
  ];

  return (
    <Line
      points={points}
      color="#4dabf7"
      lineWidth={2}
      dashed
      dashSize={0.3}
      gapSize={0.2}
    />
  );
};
